var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-wrapper"},[_c('basic-container',[_c('div',{attrs:{"slot":"header-left"},slot:"header-left"},[_vm._v("综合表单 -- 带验证")]),_c('basic-form')],1),_c('basic-container',[_c('div',{attrs:{"slot":"header-left"},slot:"header-left"},[_vm._v("水平小表单 -- 一般用于查询区")]),_c('inline-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }